import React, { Component, Fragment } from 'react';
import { Grid, Form } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { withRouter } from 'react-router';
import moment from 'moment';

import { DatePickerField } from 'Common/SemanticWrapper';
import { TitledCard } from 'Components';
import { UNCLOSED_DATES_REPORT_FORM_NAME } from 'Common/FormEnum';
import { UnclosedDatesReportFieldEnum as Fields } from 'Common/FieldEnum';

class UnclosedDatesReportFormContainer extends Component {
  render() {
    const { loading } = this.props;

    return (
      <Fragment>
        <Form name={UNCLOSED_DATES_REPORT_FORM_NAME}>
          <Grid>
            <Grid.Row>
              <Grid.Column>
                <TitledCard title="Report Settings">
                  <Grid>
                    <Grid.Row>
                      <Grid.Column>
                        <Field
                          label={'From'}
                          name={Fields.FromDate}
                          component={DatePickerField}
                          type="text"
                          openToDate={moment()}
                          disabled={loading}
                          maxDate={moment()}
                        />
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column>
                        <Field
                          label={'To'}
                          name={Fields.ToDate}
                          component={DatePickerField}
                          type="text"
                          openToDate={moment()}
                          disabled={loading}
                          maxDate={moment()}
                        />
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </TitledCard>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Form>
      </Fragment>
    );
  }
}

const validate = values => {
  const errors = {};

  if (
    !moment(values[Fields.ToDate]).isValid() ||
    !moment(values[Fields.ToDate]).isSameOrBefore(moment())
  ) {
    errors[Fields.ToDate] = 'Enter a valid To Date.';
  }
  if (
    !moment(values[Fields.FromDate]).isValid() ||
    !moment(values[Fields.FromDate]).isSameOrBefore(moment())
  ) {
    errors[Fields.FromDate] = 'Enter a valid From Date.';
  }
  if (!moment(values[Fields.ToDate]).isAfter(values[Fields.FromDate])) {
    errors[Fields.ToDate] = 'To Date must be after From Date.';
    errors[Fields.FromDate] = 'From Date must be before To Date.';
  }
  if (!values[Fields.ToDate]) {
    errors[Fields.ToDate] = 'To Date must be set.';
  }
  if (!values[Fields.FromDate]) {
    errors[Fields.FromDate] = 'From Date must be set.';
  }

  return errors;
};

const mapStateToProps = state => {
  return {
    loading: state.UnclosedDatesReportState.unclosedDates.loading,
  };
};

const UnclosedDatesReportForm = reduxForm({
  form: UNCLOSED_DATES_REPORT_FORM_NAME,
  validate,
  destroyOnUnmount: false,
})(
  withRouter(
    connect(
      mapStateToProps,
      {}
    )(UnclosedDatesReportFormContainer)
  )
);

export { UnclosedDatesReportForm };



// WEBPACK FOOTER //
// ./src/pages/uncloseddates/components/UnclosedDatesReportForm.js